import Auth from './http/models/auth/Auth'
import Bachata from './http/models/bachata/Bachata'
import BulkDelivery from './http/models/bulkDelivery/BulkDeliveryService'
import CallTouch from './http/models/calltouch/CallTouchService'
import Channels from './http/models/channels/Channels'
import Waba from './http/models/waba/Waba'
import WAChat from './http/models/wachat/WAChat'
import Webhook from './http/models/webhook/Webhook'
import Widgets from './http/models/widgets/WidgetsService'
import ChannelReport from './http/models/ChannelReport'
import ChatFirst from './http/models/ChatFirst'
import Client from './http/models/Client'
import Company from './http/models/Company'
import Conversation from './http/models/Conversation'
import File from './http/models/File'
import Groups from './http/models/Groups'
import InternalComment from './http/models/InternalComment'
import Live from './http/models/Live'
import Message from './http/models/Message'
import MessageTemplates from './http/models/MessageTemplates'
import Operators from './http/models/Operators'
import PrepareDataForMessage from './http/models/PrepareDataForMessage'
import ScenarioSteps from './http/models/ScenarioSteps'
import ScenarioVersion from './http/models/ScenarioVersion'
import Scenarios from './http/models/Scenarios'
import Stream from './http/models/Stream'
import Tag from './http/models/Tag'
import WebSocketService from './ws/WebSocketService'

export default {
  Auth,
  Bachata,
  BulkDelivery,
  CallTouch,
  Channels,
  Waba,
  WAChat,
  Webhook,
  Widgets,
  ChannelReport,
  ChatFirst,
  Client,
  Company,
  Conversation,
  File,
  Groups,
  InternalComment,
  Live,
  Message,
  MessageTemplates,
  Operators,
  PrepareDataForMessage,
  ScenarioSteps,
  ScenarioVersion,
  Scenarios,
  Stream,
  Tag,
  WebSocketService
}
